const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the admin user reports component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('adminUserBadges', ['Application','Badges', function(Application, Badges)  {
    return {
        restrict: 'E',
        scope: {
            user: '='
        },
        template: require('../../templates/directives/admin-user-badges.html'),
        controller: ['$scope', function ($scope) {
            var self = this;
            self.page = 0;
            self.per_page = 5;
            self.currentBadges = [];
            self.dateUp = false;
            self.sort = -1;
            self.actions = {
                navContent: (id) => {
                    Application.navigation.goTo('/overview/badges/' + id);
                },
                nextPage: () => {
                    self.page++;
                    self.load();
                },
                previousPage: () => {
                    self.page--;
                    self.load();
                },
                sortDate () {
                    self.dateUp = !self.dateUp;
                    if (self.dateUp){
                        self.sort = -1;
                    } else {
                        self.sort = 1;
                    }
                    self.load();
                }
            }
            self.load = () => {
                Badges.getAwardedByUser({subsubsubresource: $scope.user.toString(), page: self.page, perPage: self.per_page, sort: self.sort}).$promise
                    .then((results) => {
                        self.currentBadges = results;
                    })
            }
            self.load();
        }],
        controllerAs: 'adminUserBadges'
    };
}]);